


































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import ChangePassword from './ChangePassword.vue';
import GyriPassphrase from './GyriPassphrase.vue';
import DeleteAccount from './DeleteAccount.vue';
import LinkedAccounts from './LinkedAccountsSettings.vue';
import CreditCards from './CreditCardSettings.vue';
import MyNodes from './MyNodes.vue';
import NotificationSettings from './NotificationSettings.vue';
import PrivateKey from './PrivateKey.vue';
import ResetAccountPassword from './ResetAccountPassword.vue';
import TwoFa from './TwoFa.vue';
import UpdateDisplayName from './UpdateDisplayName.vue';
import UpdatePhone from './UpdatePhone.vue';
import VerifyEmail from './VerifyEmail.vue';
import GalaHonorContainer from '~/components/GalaHonor/index.vue';
import UserActivityLog from './UserActivityLog.vue';

@Component({
  components: {
    TwoFa,
    FullScreenDialog,
    GalaHonorContainer,
    CreditCards,
    VerifyEmail,
    UpdatePhone,
    UpdateDisplayName,
    ChangePassword,
    ResetAccountPassword,
    PrivateKey,
    LinkedAccounts,
    NotificationSettings,
    MyNodes,
    DeleteAccount,
    GyriPassphrase,
    UserActivityLog,
  },
})
export default class SettingsContainer extends Vue {
  @Prop({ type: Object, default: { title: '', componentName: '' } })
  readonly activeSettingsPage!: { title: string; componentName: string };
  @Prop({ type: Boolean, default: true }) readonly dialog!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isComponentRoute!: boolean;

  settingsDialog = false;
  settingsComponents: any = {
    TwoFa,
    GalaHonorContainer,
    VerifyEmail,
    UpdatePhone,
    ChangePassword,
    ResetAccountPassword,
    PrivateKey,
    CreditCards,
    MyNodes,
    UpdateDisplayName,
    LinkedAccounts,
    NotificationSettings,
    DeleteAccount,
    GyriPassphrase,
    UserActivityLog,
  };

  created() {
    if (this.isComponentRoute) {
      this.settingsDialog = true;
    }
  }

  get activeComponent() {
    return this.settingsComponents[this.activeSettingsPage.componentName];
  }

  @Emit()
  closeDialog() {
    this.settingsDialog = false;
    if (this.isComponentRoute) {
      this.$router.push('/account');
    }
  }

  @Watch('activeComponent')
  updateOpenDialog(val: any) {
    this.settingsDialog = !!val;
  }
}
